module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ForgotPassword", "Forgot password?") ))==null?'':__t)+
'</legend><div><label for="forgot-email-input">'+
((__t=( i18n.tc("ForgotPassword", "Email/Username") ))==null?'':__t)+
'</label> <input type="text" id="forgot-email-input" data-input="forgot-email" required></div><div class="input"><small><a href="#" data-click="user-login">'+
((__t=( i18n.tc("ForgotPassword", "Log in") ))==null?'':__t)+
'</a>| <a href="#" data-click="user-create">'+
((__t=( i18n.tc("ForgotPassword", "Register new account") ))==null?'':__t)+
'</a></small></div></fieldset><fieldset class="button-wrap"><button class="primary" data-click="forgot-submit" disabled="disabled">'+
((__t=( i18n.tc("ForgotPassword", "Request password") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
